import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { primaryBlueColor } from "../common/commonButtonStyles";


//inline styles
const InlineStyles = {
    TableHeader: {
        backgroundColor: primaryBlueColor,
        color: "white",
        position: 'sticky',
        top: 0,
        zIndex: 1,
        height: "50px",
        width:"200px"
    },
    TableCells: {
        color: 'black',
        fontSize: '12px',
        height: '44px',
        padding: '0px'
    },
    TableBodyRows: {
        border: '1px solid #ddd', marginTop: "10px", paddingTop: "15px", verticalAlign: "top"
    },
    TableBodyRowCells: {
        height: '20px', padding: '0px'
    },
    txnStatusTableCell: {
        height: "20px", padding: "3px", width:"200px"
    },
    txnStatus: {
        position: "relative", width: "200x", height: "32"
    },
    MoreVertIconStyle: {
        color: 'FF5A01',
        background: 'transparent',
        cursor: 'pointer',
        transform: 'rotate(90deg)'
    },

}
export const AddTxnStatus = ({

    handleInputChange,
    row,
    viewMode,
    validationStatus,
}) => {
    console.log("txnStatus row updated inner", validationStatus)
    return (
        <Table>
            <TableHead
                style={InlineStyles.TableHeader}>
                <TableRow style={{ backgroundColor: primaryBlueColor }}>
                    <TableCell className='TableCell'>Transaction Status</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                    <TableRow 
                    style={InlineStyles.TableBodyRows}>
                        <TableCell sx={InlineStyles.txnStatusTableCell}>
                            <TextField
                                value={row.name}
                                onChange={(e) => handleInputChange( 'name', e.target.value)}
                                sx={InlineStyles.txnStatus}
                                size="small"
                                placeholder='Enter Details Here'
                                disabled={viewMode}
                            /><br />
                            {validationStatus?.name && (
                                <span style={{ color: 'red' }}>{validationStatus?.name}</span>
                            )}
                        </TableCell>
                    </TableRow>
                {/* ))} */}
            </TableBody>
        </Table>
    )
}